module.exports = __webpack_public_path__ + "img/gallery_layout5.aba1cedd.png";